import { render, staticRenderFns } from "./PopupPhuAssign.vue?vue&type=template&id=92b3940a&scoped=true"
import script from "./PopupPhuAssign.vue?vue&type=script&lang=js"
export * from "./PopupPhuAssign.vue?vue&type=script&lang=js"
import style0 from "./PopupPhuAssign.vue?vue&type=style&index=0&id=92b3940a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92b3940a",
  null
  
)

export default component.exports